import React from 'react';
import { Outlet } from 'react-router-dom';
import styles from './base.module.css';
import Header from '../Header';

const BaseLayout: React.FC = () => {
  return (
    <div className={styles.base}>
      <Header />
      <Outlet />
    </div>
  );
};

export default BaseLayout;
